import React from 'react';
import { Typography, makeStyles, Grid, Tooltip } from '@material-ui/core';
import Moment from 'react-moment';
import useWindowSize from '../../../customHooks/useWindowSize';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  container: {
    margin: '8px 0'
  },
  tooltipWidthDesktop: {
    maxWidth: 500
  },
  tooltipWidthMobile: {
    maxWidth: 300
  }
});

const IdendityDescription = (props) => {
  const { identity } = props;
  const classes = useStyles();
  const windowSize = useWindowSize();
  const { t } = useTranslation();

  const delay = 200;
  const touchDelay = 300;
  const placement = 'bottom-start';
  const tooltipWitdh = (windowSize.width > 500 ? classes.tooltipWidthDesktop : classes.tooltipWidthMobile);

  return (
    <Grid
      container
      wrap='nowrap'
    >
      <div style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <Tooltip title={identity.userId} enterDelay={delay} enterTouchDelay={touchDelay} placement={placement} classes={{ tooltip: tooltipWitdh }}>
          <Typography variant='subtitle1' style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }} >
            {'ID: ' + identity.userId}
          </Typography>
        </Tooltip>
        <Tooltip title={identity.status} enterDelay={delay} enterTouchDelay={touchDelay} placement={placement} classes={{ tooltip: tooltipWitdh }}>
          <Typography variant='body1' style={{ marginTop: 5, textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
            {t('identityListView:state') + identity.status}
          </Typography>
        </Tooltip>
        {(identity.name || identity.firstName || identity.lastName) &&
          <Typography variant='body2' style={{ marginTop: 5, textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
            {t('identityListView:name')} {identity.name && identity.name + ' '} {identity.firstName && identity.firstName + ' '} {identity.lastName && identity.lastName}
          </Typography>}
        <Typography variant='body2'>
          <Moment format='DD/MM/YYYY HH:mm:ss'>{identity.createdAt}</Moment>
        </Typography>
      </div>
    </Grid>
  );
};

export default IdendityDescription;
